import React from "react";
import { BookingStatus } from "generated/types/types";
import { useTranslation } from "react-i18next";

type Properties = {
    regNo?: string;
    bookingId: string;
    bookingStatus: BookingStatus;
};

const HeroKeys : Record<BookingStatus, { heading: string; desc: string }> = {
  [BookingStatus.Confirmed]: {
    heading: "booking_hero_confirmed",
    desc: "booking_hero_confirmed_desc",
  },
  [BookingStatus.AlternativeDateOffered]: {
    heading: "booking_hero_request",
    desc: "booking_hero_request_desc", 
  },
  [BookingStatus.Declined]: {
    heading: "booking_hero_declined",
    desc: "booking_hero_declined_desc",
  },
  [BookingStatus.Cancelled]: {
    heading: "booking_hero_cancelled",
    desc: "booking_hero_cancelled_desc",
  },
  [BookingStatus.Received]: {
    heading: "booking_hero_received",
    desc: "booking_hero_received_desc",
  },
  [BookingStatus.Expired]: {
    heading: "booking_hero_expired",
    desc: "booking_hero_expired_desc",
  },
} as const;

export const BookingHero: React.FC<Properties> = (props) => {
    const { t } = useTranslation();
    const keys = HeroKeys[props.bookingStatus];

    const vars = {
        bookingId: props.bookingId,
        regNo: props.regNo ?? "",
    };

   return (
    <div className="body-header">
      <h1>{t(keys.heading, vars)}</h1>
      <p>{t(keys.desc, vars)}</p>
    </div>
  );
};
